<template>
  <div>
    <div
      :id="modalId"
      :key="modalId"
      class="ui basic tiny modal">
      <div
        v-if="generatingPDF === true"
        class="ui icon header">
        <i class="ui loading spinner icon"/>
        <div class="content">
          <h2>{{ $t('patients.modal.generating', { report: $t('patientInfo.impactReports') }) }}</h2>
          <label
            :for="linkId"
            class="ui teal label">{{ reportLanguage }}</label>
        </div>
      </div>

      <div
        v-if="generatingPDF===false"
        class="ui icon header">
        <i class="download icon"/>
        <div class="content">
          <h2>{{ $t('patients.modal.downloadMessage', { report: $t('patientInfo.impactReports') }) }}</h2>
          <label
            :for="linkId"
            class="ui teal label">{{ reportLanguage }}</label>
        </div>
      </div>

      <div style="text-align: center">
        <div
          :class="{ generating: generatingPDF, generated: !generatingPDF }"
          :disable="generatingPDF"
          class="ui small left icon right action input">
          <input
            type="text"
            :id="linkId"
            :value="pdfShortLink || pdfLongLink">
          <i class="linkify icon"/>
          <button
            @click="copyToClipboard"
            :class="{ disabled: generatingPDF }"
            class="ui small primary button">
            <i class="copy icon"/>
            {{ $t('patients.modal.copy') }}
          </button>
        </div>

        <h4
          v-if="generatingPDF===true"
          style="font-weight: normal">
          {{ $t('patients.modal.holdOn') }}
        </h4>
        <h4
          v-else-if="generatingPDF===false"
          style="font-weight: normal">
          {{ $t('patients.modal.ready') }}
        </h4>

        <br>

        <div
          @click="hideModal"
          :class="{ generating: generatingPDF, generated: !generatingPDF, inverted: generatingPDF }"
          :disable="generatingPDF"
          class="ui left floated cancel button">
          <i class="cancel icon"/>
          {{ $t('patients.modal.cancel') }}
        </div>

        <div
          @click="openInNewTab"
          :class="{ generating: generatingPDF, generated: !generatingPDF, inverted: generatingPDF, green: !generatingPDF }"
          :disable="generatingPDF"
          class="ui right floated ok button">
          <i class="download icon"/>
          {{ $t('patients.modal.download') }}
        </div>
      </div>
    </div>

    <div
      :id="errorModalId"
      class="ui mini modal">
      <div class="header">
        <i class="exclamation triangle triangle icon"/>
        {{ $t('patients.modal.error') }}
      </div>

      <div class="content">
        <p>{{ $t('patients.modal.failed', { report: $t('patientInfo.impactReports') }) }}</p>
        <p>{{ $t('patients.modal.retryMessage') }}</p>
      </div>

      <div class="actions">
        <div class="ui left floated cancel button">
          <i class="cancel icon"/>
          {{ $t('patients.modal.cancel') }}
        </div>
        <div
          @click="retryGenerateMIR"
          class="ui positive button">
          <i class="download icon"/>
          {{ $t('retry') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GeneratePDFModal',
  props: {
    generatingPDF: {
      required: true
    },
    pdfShortLink: {
      required: true
    },
    pdfLongLink: {
      required: true
    },
    language: {
      required: true
    }
  },
  data () {
    return {
      linkId: 'mir-link-' + this._uid
    }
  },
  computed: {
    modalId: function () {
      return 'generate-PDF-' + this._uid
    },
    errorModalId: function () {
      return 'mir-error-modal-' + this._uid
    },
    reportLanguage: function () {
      switch (this.language) {
        case 'en':
          return 'English'
          break
        case 'de':
          return 'Deutsch'
          break
        default:
          return 'en'
      }
    }
  },
  watch: {
    modalId: {
      handler (newValue) {
        if (newValue) {
          this.$emit('mir-modal-id', newValue)
        }
      },
      immediate: true
    },
    errorModalId: {
      handler (newValue) {
        if (newValue) {
          this.$emit('mir-error-modal-id', newValue)
        }
      },
      immediate: true
    }
  },
  methods: {
    openInNewTab: function () {
      if (this.generatingPDF === false && this.pdfLongLink !== null) {
        window.open(this.pdfLongLink, '_blank')
      }
      this.hideModal()
    },
    copyToClipboard: function () {
      if (this.generatingPDF === false && this.pdfShortLink !== null) {
        document.getElementById(this.linkId).select()
        document.execCommand('copy')
      }
      this.hideModal()
    },
    retryGenerateMIR: function () {
      this.$emit('retry-generate-mir')
    },
    hideModal: function () {
      $('#' + this.modalId).modal('hide')
    }
  },
  beforeDestroy () {
    let modals = [$('#' + this.modalId), $('#' + this.errorModalId)]
    modals.forEach((modal) => {
      if (modal !== null) { modal.remove() }
    })
  }
}
</script>
<style scoped>
.dimmed.dimmable > .ui.modals.dimmer.visible {
  display: flex !important;
}
.generating {
  /*visibility: hidden !important;*/
  opacity: 0 !important;
}
.generated {
  transition: opacity 0.5s !important;
  opacity: 1 !important;
}
</style>
